module.exports = __webpack_public_path__ + "static/img/bg_fwys@2x.4d34ae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktb_min/bg_fwys@2x.png
// module id = tDJS
// module chunks = 69